import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import FifthStep from './FifthStep';
import FirstStep from './FirstStep';
import FourthStep from './FourthStep';
import SecondStep from './SecondStep';
import ThirdStep from './ThirdStep';
import SixthStep from './SixthStep';
import '../../assets/styles/form.scss';

import { FormStepContext } from './FormStepContext';

const STEPS = [
  <FirstStep />,
  <SecondStep />,
  <ThirdStep />,
  <FourthStep />,
  <FifthStep />,
  <SixthStep />,
];

const Stage = ({
  currentStep,
  activeStep,
  setStep,
  register,
  watch,
  projectType,
  setProjectType,
  projectDomain,
  setProjectDomain,
  resetField,
  getValues,
  reset,
  uploadedFile,
  setUploadedFile,
  formStateErrors,
  isSent,
  setSending,
  isError,
  errorMessage,
}) => {
  const scrollContainerRef = useRef(null);
  const currentStepIndex = currentStep.id - 1;

  useEffect(() => {
    if (activeStep === currentStep.id && scrollContainerRef.current) {
      scrollContainerRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [activeStep, currentStep.id]);

  return (
    <FormStepContext.Provider
      value={{
        currentStep,
        activeStep,
        setStep,
        register,
        watch,
        projectType,
        setProjectType,
        projectDomain,
        setProjectDomain,
        resetField,
        getValues,
        reset,
        uploadedFile,
        setUploadedFile,
        formStateErrors,
        isSent,
        setSending,
        isError,
        errorMessage,
      }}
    >
      <div
        className={`laForm__stage-item${
          activeStep === currentStep.id ? ' activeStage' : ''
        }`}
        ref={scrollContainerRef}
      >
        {STEPS[currentStepIndex]}
      </div>
    </FormStepContext.Provider>
  );
};

export default Stage;

Stage.propTypes = {
  currentStep: PropTypes.object.isRequired,
  activeStep: PropTypes.any,
  setStep: PropTypes.func,
  projectType: PropTypes.string,
  setProjectType: PropTypes.func,
  projectDomain: PropTypes.string,
  setProjectDomain: PropTypes.func,
  uploadedFile: PropTypes.any,
  setUploadedFile: PropTypes.func,
};
